module.exports = __webpack_public_path__ + "img/Identity.5ec048dc.svg";